module.exports = __webpack_public_path__ + "img/ebcZh-twW.c4ea1a27.svg";